import React, { Component } from 'react';
import './MenuIcon.css';

class MenuIcon extends Component {
  render() {
    let { open } = this.props;
    return (
      <div className={"MenuIcon" + (open ? " MenuIcon--open" : "")}>
        <div className="MenuIcon__stick"></div>
        <div className="MenuIcon__stick"></div>
        <div className="MenuIcon__stick"></div>
      </div>
    );
  }
}

export default MenuIcon;



/** WEBPACK FOOTER **
 ** ./src/components/MenuIcon/index.js
 **/